<template>
  <div class="topbox">
    <div class="seebs">
      <div class="bsbtn">
      <el-tooltip  effect="dark" content="买卖盘" placement="left">
        <!-- <span class="curson1 curbtn" @mousemove="showJS(2)" @mouseout="hideJs(0)" @click="changebs('bs')">买卖盘</span> -->
        <span  class="curson1 curbtn" @click="changebs('bs')">买卖盘</span>
      </el-tooltip>
      </div>
      <div class="bsbtn">
      <el-tooltip  effect="dark" content="买盘" placement="left">
        <!-- <span class="curson2 curbtn" @mousemove="showJS(3)" @mouseout="hideJs(1)" @click="changebs('b')">买盘</span> -->
        <span class="curson2 curbtn" @click="changebs('b')">买盘</span>
      </el-tooltip>
      </div>
      <div class="bsbtn">
      <el-tooltip  effect="dark" content="卖盘" placement="left">
        <!-- <span class="curson3 curbtn" @mousemove="showJS(4)" @mouseout="hideJs(1)" @click="changebs('s')">卖盘</span> -->
        <span class="curson3 curbtn" @click="changebs('s')">卖盘</span>
      </el-tooltip>
      </div>
    </div>
    <div class="introud">
      <div class="graycolor" style="width:20%;textAlign:left;paddingLeft:5px;box-sizing:border-box;">方向</div>
      <div class="graycolor" style="width:20%;textAlign:center;">价格</div>
      <div class="graycolor" style="width:12%;textAlign:center;">数量</div>
      <div style="width:20%;" class="graycolor">
        <span class="curson" style="display:inline-block;width:100%;textAlign:center" @mousemove="showJS(0)" @mouseout="hideJs(0)">总计</span>
      </div>
      <div style="width:30%;" class="graycolor">
        <span class="curson" style="display:inline-block;width:100%;textAlign:center" @mousemove="showJS(1)" @mouseout="hideJs(1)">总额</span>
      </div>
      <!-- <div class="topbsbtn btn" @click="changebs">{{ bsName[bstype] }}</div> -->
    </div>
    <div class="lineBox"></div>
    <div class="ListBox">
      <div class="List" :class="bsClassName[bstype]">
        <div class="allData">
          <div class="sm-allData">
            <ul v-for="(item, id) in sellLstPc" :key="id" @click="changeSell(item, id)">
              <li style="color:#41B37D;text-align:left;width:20%" :style="id === sellLstPc.length - 1 ? 'line-height: 18px' : ''">
                销售{{ (sellLstPc.length - id) | idformatter }}
              </li>
              <li style="text-align:center;width:20%" :style="id === sellLstPc.length - 1 ? 'line-height: 18px' : ''">
                {{
                  item[0] != '--'
                    ? item[0].toFixed(selectItem.coinDigitalNum)
                    : item[0]
                }}
              </li>
              <li style="text-align:center;width:10%" :style="id === sellLstPc.length - 1 ? 'line-height: 18px' : ''">
                {{
                  item[1] == '--'
                    ? item[1]
                    : Number(item[1]).toFixed(selectItem.quantityNum)
                }}
              </li>
              <li style="width:20%" :style="id === sellLstPc.length - 1 ? 'line-height: 18px' : ''">
                {{
                  item[2] == '--'
                    ? item[2]
                    : Number(item[2]).toFixed(selectItem.quantityNum)
                }}
              </li>
              <li style="color:#FFC108;width:30%" :style="id === sellLstPc.length - 1 ? 'line-height: 18px' : ''">
                {{
                  item[3] | amountWFormat
                }}
              </li>
              <span class="latest__sellactive" :style="{ width: item.progress + '%' }"></span>
            </ul>
          </div>
        </div>
        <div class="lineBox"></div>
        <div class="allDataBottom">
          <ul v-for="(item, id) in buyLstPc" :key="id" @click="changeBuy(item, id)">
            <li style="color:#D94066;text-align:left;width:20%" :style="id === 0 ? 'line-height: 18px' : ''">
              采购{{ (id + 1) | idformatter }}
            </li>
            <li style="text-align:center;width:20%" :style="id === 0 ? 'line-height: 18px' : ''">
              {{
                item[0] != '--'
                  ? item[0].toFixed(selectItem.coinDigitalNum)
                  : item[0]
              }}
            </li>
            <li style="text-align:center;width:10%" :style="id === 0 ? 'line-height: 18px' : ''">
              {{
                item[1] == '--'
                  ? item[1]
                  : Number(item[1]).toFixed(selectItem.quantityNum)
              }}
            </li>
            <li style="width:20%" :style="id === 0 ? 'line-height: 18px' : ''">
              {{
                item[2] == '--'
                  ? item[2]
                  : Number(item[2]).toFixed(selectItem.quantityNum)
              }}
            </li>
            <li style="color:#FFC108;width:30%" :style="id === 0 ? 'line-height: 18px' : ''">
              {{
                item[3] | amountWFormat
              }}
            </li>
            <span class="latestactive" :style="{ width: item.progress + '%' }"></span>
          </ul>
        </div>
      </div>
    </div>
    <div class="lineBox"></div>
    <!-- 按钮移动操作 -->
    <div
      v-if="isShowCalcFor"
      class="calcFormula"
      :style="`right:${nounFormula[explainId].right};top:${nounFormula[explainId].top}`"
    >
      <div class="interprete">{{ nounFormula[explainId].noun }}</div>
      <div class="calcFor">
        {{ nounFormula[explainId].formula }}
      </div>
    </div>
  </div>
</template>
<script>

/*global hqProtocol hqWs*/
import { mapGetters } from 'vuex'
export default {
  name: 'QuotationLineCC',
  filters: {
    idformatter(index) {
      switch (index) {
        case 1:
          return '①'
        case 2:
          return '②'
        case 3:
          return '③'
        case 4:
          return '④'
        case 5:
          return '⑤'
        case 6:
          return '⑥'
        case 7:
          return '⑦'
        case 8:
          return '⑧'
        default:
          return ''
      }
    }
  },
  data() {
    return {
      reloadTimer: null,
      topNum: 6,
      isShowCalcFor: false,
      nounFormula: [
        {
          id: 0,
          noun: '',
          formula: '总计 : 买卖相应价格档位所需下单总数量。',
          right: '140px',
          top: '-40px'
        },
        { // 最新价
          id: 1,
          noun: '',
          formula: '总额 : 买卖相应价格档位所需下单总金额。',
          right: '70px',
          top: '-40px'
        },
        { // 买卖盘
          id: 2,
          noun: '',
          formula: '买卖盘',
          right: '280px',
          top: '-40px'
        },
        { // 买盘
          id: 3,
          noun: '',
          formula: '买盘',
          right: '255px',
          top: '-40px'
        },
        { // 买盘
          id: 4,
          noun: '',
          formula: '卖盘',
          right: '230px',
          top: '-40px'
        }
      ],
      explainId: 0,
      isEndDrag: false,
      // 买卖盘
      bstypes: ['bs', 'b', 's'],
      bstype: 'bs',
      bsClassName: {
        bs: 'ListBuySell',
        b: 'ListBuy',
        s: 'ListSell'
      },
      bsName: {
        bs: '买卖盘',
        b: '买盘',
        s: '卖盘'
      }
    }
  },
  computed: {
    ...mapGetters([
      'item',
      'buyMaxAmount',
      'sellMaxAmount',
      'commodityStrategyGetter'
    ]),
    selectCommodityStrategy() {
      const currentSymbol = this.item?.symbolId ? this.item.symbolId : this.$store.state.hqData.marketDetails[0]?.symbolId ? this.$store.state.hqData.marketDetails[0].symbolId : ''
      if (
        currentSymbol &&
        this.commodityStrategyGetter.length > 0
      ) {
        for (const CommodityStrategy of this.commodityStrategyGetter) {
          if (currentSymbol == CommodityStrategy.commodityId) {
            return CommodityStrategy
          }
        }
      }
      return {
        canBuy: '--',
        canDqDelivery: '--',
        canSell: '--',
        canShow: '--',
        canTqDelivery: '--',
        canTqTransfer: '--',
        canTransfer: '--',
        commodityCode: '--',
        commodityId: null,
        commodityName: '--',
        feeStrategyId: '--',
        guidePrice: '--',
        holdStrategyId: '--',
        margin: '--',
        marginStrategyId: '--',
        marginType: '--',
        marketPrice: '--',
        maxHoldAmount: '--',
        maxSingleTradeAmount: '--',
        maxUpDownWidth: '--',
        minAmountChange: 0.01,
        minPickupAmount: '--',
        minPriceChange: 0.01,
        minSingleTradeAmount: '--',
        offerEndTime: 0,
        openFee: '--',
        openFeeType: '--',
        pickupCountdown: '--',
        pickupStandard: '--',
        pickupStartTime: 0,
        tradeStrategyId: '--',
        transferFee: '--',
        transferFeeType: '--',
        unitNumeral: '--',
        unitQuantifier: '--',
        sellMargin: '--',
        sellMarginType: '--'
      }
    },
    selectItem() {
      if (this.item) {
        return {
          coinDigitalNum: this.item.coinDigitalNum,
          quantityNum: this.item.quantityNum
        }
      } else {
        return {
          coinDigitalNum: 2,
          quantityNum: 2 // 数量
        }
      }
    },
    data() {
      return this.item?.symbolId
    },
    buyLstPc() {
      // 计算总额 每一个top对应的金额
      const arr = JSON.parse(JSON.stringify(this.$store.state.hqData.buyLst)).reverse()
      for (let i = 0; i < arr.length; i++) {
        const number = arr[i][1] === '--' ? 0 : Number(arr[i][1])
        const price = arr[i][0] === '--' ? 0 : Number(arr[i][0])
        arr[i][3] = this.selectCommodityStrategy.marginType == '1'
          ? number * this.selectCommodityStrategy.margin * this.selectCommodityStrategy.unitNumeral
          : price * number * this.selectCommodityStrategy.margin * this.selectCommodityStrategy.unitNumeral
      }
      // 计算总额 每一个top对应的金额累加
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][0] === '--') {
          arr[i][3] = '--'
        } else {
          if (i >= 1) {
            const lastn =
              arr[i - 1][3] && typeof arr[i - 1][3] === 'number'
                ? arr[i - 1][3]
                : 0
            const thisn = arr[i][3] && typeof arr[i][3] === 'number' ? arr[i][3] : 0
            arr[i][3] =
              arr[i][3] === '--'
                ? '--'
                : lastn + thisn
          }
        }
      }
      let item = [].concat(arr)
      item = item.slice(0, this.topNum)
      let buyMaxAmount = 0
      item.map((i) => { if (i[1] > buyMaxAmount) buyMaxAmount = i[1] })
      if (item) {
        for (let i = 0; i < item.length; i++) {
          if (Number(buyMaxAmount) == 0) {
            item[i].progress = 0
          } else {
            const num = Number(item[i][1]) > 0 ? Number(item[i][1]) : 0
            item[i].progress = (num / Number(buyMaxAmount)) * 100
          }
        }
        return item
      } else {
        return '--'
      }
    },
    sellLstPc() {
      // 计算总额 每一个top对应的金额
      const arr = JSON.parse(JSON.stringify(this.$store.state.hqData.sellLst))
      for (let i = 0; i < arr.length; i++) {
        const number = arr[i][1] === '--' ? 0 : Number(arr[i][1])
        const price = arr[i][0] === '--' ? 0 : Number(arr[i][0])
        arr[i][3] = this.selectCommodityStrategy.sellMarginType == '1'
          ? number * this.selectCommodityStrategy.sellMargin * this.selectCommodityStrategy.unitNumeral
          : price * number * this.selectCommodityStrategy.sellMargin * this.selectCommodityStrategy.unitNumeral
      }
      // 计算总额 每一个top对应的金额累加
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][0] === '--') {
          arr[i][3] = '--'
        } else {
          if (i >= 1) {
            const lastn =
              arr[i - 1][3] && typeof arr[i - 1][3] === 'number'
                ? arr[i - 1][3]
                : 0
            const thisn = arr[i][3] && typeof arr[i][3] === 'number' ? arr[i][3] : 0
            arr[i][3] =
              arr[i][3] === '--'
                ? '--'
                : lastn + thisn
          }
        }
      }
      let item = [].concat(arr).reverse()
      const itemLength = item.length
      item.length >= this.topNum
        ? (item = item.slice(itemLength - this.topNum, itemLength))
        : (item = item.slice(0, this.topNum))
      let sellMaxAmount = 0
      item.map((i) => { if (i[1] > sellMaxAmount) sellMaxAmount = i[1] })
      if (item) {
        for (let i = 0; i < item.length; i++) {
          if (Number(sellMaxAmount) == 0) {
            item[i].progress = 0
          } else {
            const num = Number(item[i][1]) > 0 ? Number(item[i][1]) : 0
            item[i].progress = (num / Number(sellMaxAmount)) * 100
          }
        }
        return item
      } else {
        return '--'
      }
    }
  },
  watch: {
    item: function(val, oldVal) {
      this.items()
    }
  },
  created: function() {
    this.items()
  },
  mounted: function() {
  },
  destroyed() {
    if (this.reloadTimer) {
      clearInterval(this.reloadTimer)
      this.reloadTimer = null
    }
  },
  methods: {
    changebs(t) {
      if (t) {
        this.bstype = t
      } else {
        const ty = this.bstypes.indexOf(this.bstype)
        ty === this.bstypes.length - 1 ? this.bstype = this.bstypes[0] : this.bstype = this.bstypes[ty + 1]
      }
    },
    endDrag() {
      this.isEndDrag = true
      setTimeout(() => {
        this.isEndDrag = false
      }, 100)
    },
    showJS(id) {
      this.explainId = id
      this.isShowCalcFor = true
    },
    hideJs(id) {
      this.explainId = id
      this.isShowCalcFor = false
    },
    items() {
      hqProtocol.param_top.symbol = this.data
      if (this.data && this.data != '--') {
        hqWs.send(hqProtocol.param_top)
      } else {
        if (this.reloadTimer) {
          clearTimeout(this.reloadTimer)
          this.reloadTimer = null
        }
        this.reloadTimer = setTimeout(
          () => {
            this.items()
          },
          window.g.TOP_REFRESH_TIME ? window.g.TOP_REFRESH_TIME : 1000
        )
      }
    },
    changeSell(obj, index) {
      const oSellOne = obj
      this.$store.commit('sellOne', oSellOne)
      // 添加top点击向交易弹窗传值 闪电下单
      this.$store.commit('topClickInfo', {
        type: 'buy', // buy/sell 对应买方向订立
        l: index // top1:0
      })
      this.$store.commit('topCLickNum')
    },
    changeBuy(obj, index) {
      const oBuyOne = obj
      this.$store.commit('buyOne', oBuyOne)
      // 添加top点击向交易弹窗传值 闪电下单
      this.$store.commit('topClickInfo', {
        type: 'sell', // buy/sell 对应卖方向订立
        l: index // top1:0
      })
      this.$store.commit('topCLickNum')
    }
  }
}
</script>
<style scoped lang="scss">
.topbox {
  height: 100%;
  width: 100%;
  position: relative;
  // 买卖盘
  .seebs{
    height: 40px;
    position: relative;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    .bsbtn{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .curbtn{
      font-size: 0;
      display: inline-block;
      width: 20px;
      height: 20px;
      margin:0 8px 0 0;
    }
    .curson1{
      background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgb3BhY2l0eT0iLjUiIHg9IjIiIHk9IjEwLjUzMSIgd2lkdGg9IjYiIGhlaWdodD0iNy40NjkiIHJ4PSIxIiBmaWxsPSIjRTk0MzU5Ii8+PHJlY3Qgb3BhY2l0eT0iLjUiIHg9IjIiIHk9IjIiIHdpZHRoPSI2IiBoZWlnaHQ9IjcuNSIgcng9IjEiIGZpbGw9IiMwMEExNzEiLz48cGF0aCBkPSJNOS41IDNhLjUuNSAwIDAgMSAuNS0uNWg3LjVhLjUuNSAwIDAgMSAuNS41di41YS41LjUgMCAwIDEtLjUuNUgxMGEuNS41IDAgMCAxLS41LS41VjN6bTAgNi43NWEuNS41IDAgMCAxIC41LS41aDcuNWEuNS41IDAgMCAxIC41LjV2LjVhLjUuNSAwIDAgMS0uNS41SDEwYS41LjUgMCAwIDEtLjUtLjV2LS41em0wLTMuMzc1YS41LjUgMCAwIDEgLjUtLjVoNy41YS41LjUgMCAwIDEgLjUuNXYuNWEuNS41IDAgMCAxLS41LjVIMTBhLjUuNSAwIDAgMS0uNS0uNXYtLjV6bTAgNi43NWEuNS41IDAgMCAxIC41LS41aDcuNWEuNS41IDAgMCAxIC41LjV2LjVhLjUuNSAwIDAgMS0uNS41SDEwYS41LjUgMCAwIDEtLjUtLjV2LS41em0wIDMuMzc1YS41LjUgMCAwIDEgLjUtLjVoNy41YS41LjUgMCAwIDEgLjUuNXYuNWEuNS41IDAgMCAxLS41LjVIMTBhLjUuNSAwIDAgMS0uNS0uNXYtLjV6IiBmaWxsPSIjMzgzRTRBIi8+PC9zdmc+) no-repeat 50%;
      background-size: 100%;
    }
    .curson2{
      background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgb3BhY2l0eT0iLjUiIHg9IjIiIHk9IjIiIHdpZHRoPSI2IiBoZWlnaHQ9IjE1Ljk2OSIgcng9IjEiIGZpbGw9IiNFOTQzNTkiLz48cGF0aCBkPSJNOS41IDNhLjUuNSAwIDAgMSAuNS0uNWg3LjVhLjUuNSAwIDAgMSAuNS41di41YS41LjUgMCAwIDEtLjUuNUgxMGEuNS41IDAgMCAxLS41LS41VjN6bTAgNi43NWEuNS41IDAgMCAxIC41LS41aDcuNWEuNS41IDAgMCAxIC41LjV2LjVhLjUuNSAwIDAgMS0uNS41SDEwYS41LjUgMCAwIDEtLjUtLjV2LS41em0wLTMuMzc1YS41LjUgMCAwIDEgLjUtLjVoNy41YS41LjUgMCAwIDEgLjUuNXYuNWEuNS41IDAgMCAxLS41LjVIMTBhLjUuNSAwIDAgMS0uNS0uNXYtLjV6bTAgNi43NWEuNS41IDAgMCAxIC41LS41aDcuNWEuNS41IDAgMCAxIC41LjV2LjVhLjUuNSAwIDAgMS0uNS41SDEwYS41LjUgMCAwIDEtLjUtLjV2LS41em0wIDMuMzc1YS41LjUgMCAwIDEgLjUtLjVoNy41YS41LjUgMCAwIDEgLjUuNXYuNWEuNS41IDAgMCAxLS41LjVIMTBhLjUuNSAwIDAgMS0uNS0uNXYtLjV6IiBmaWxsPSIjMzgzRTRBIi8+PC9zdmc+) no-repeat 50%;
      background-size: 100%;
    }
    .curson3{
      background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgb3BhY2l0eT0iLjUiIHg9IjIiIHk9IjIiIHdpZHRoPSI2IiBoZWlnaHQ9IjE1Ljk2OSIgcng9IjEiIGZpbGw9IiMwMEExNzEiLz48cGF0aCBkPSJNOS41IDNhLjUuNSAwIDAgMSAuNS0uNWg3LjVhLjUuNSAwIDAgMSAuNS41di41YS41LjUgMCAwIDEtLjUuNUgxMGEuNS41IDAgMCAxLS41LS41VjN6bTAgNi43NWEuNS41IDAgMCAxIC41LS41aDcuNWEuNS41IDAgMCAxIC41LjV2LjVhLjUuNSAwIDAgMS0uNS41SDEwYS41LjUgMCAwIDEtLjUtLjV2LS41em0wLTMuMzc1YS41LjUgMCAwIDEgLjUtLjVoNy41YS41LjUgMCAwIDEgLjUuNXYuNWEuNS41IDAgMCAxLS41LjVIMTBhLjUuNSAwIDAgMS0uNS0uNXYtLjV6bTAgNi43NWEuNS41IDAgMCAxIC41LS41aDcuNWEuNS41IDAgMCAxIC41LjV2LjVhLjUuNSAwIDAgMS0uNS41SDEwYS41LjUgMCAwIDEtLjUtLjV2LS41em0wIDMuMzc1YS41LjUgMCAwIDEgLjUtLjVoNy41YS41LjUgMCAwIDEgLjUuNXYuNWEuNS41IDAgMCAxLS41LjVIMTBhLjUuNSAwIDAgMS0uNS0uNXYtLjV6IiBmaWxsPSIjMzgzRTRBIi8+PC9zdmc+) no-repeat 50%;
      background-size: 100%;
    }
  }
  .title {
    height: 40px;
    margin-bottom: 4px;
    line-height: 44px;
    font-size: 14px;
    padding-left: 15px;
    box-sizing: border-box;
    color: #f0f1f4;
    background: #111217;
  }

  .top {
    width: 100%;
    height: 30px;
    background: #111217;
    // box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.5);
    border: 0px solid rgba(151, 151, 151, 1);
    line-height: 30px;
    font-size: 16px;
    box-sizing: border-box;
    text-align: left;
    padding-left: 15px;

    span {
      color: #f0f1f4;
    }
  }

  .introud {
    position: relative;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: right;
    font-size: 14px;
    line-height: 22px;
    height: 22px;
    width: 100%;
    padding: 0 5%;
    box-sizing: border-box;

    div {
      // flex: 1;
    font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #989898;
      // display: flex;
      // justify-content: center;
      // align-items: center;
    }
    .topbsbtn{
      position: absolute;
      z-index: 1001;
    }
  }

  .introud .graycolor {
    color: #989898;
  }

  .curson {
    cursor: pointer;
    color: #989898;
  }
  .ListBox{
    position: relative;
    height: calc(100% - 57px);
    overflow: hidden;
    width: 100%;
  }
  .ListBuy{
    top: -100%;
  }
  .ListSell {
    top: 0;
  }
  .ListBuySell{
    top: -50%;
  }
  .List {
    position: relative;
    z-index: 999;
    margin: 0 auto;
    height: 200%;
    width: 100%;
    display: flex;
    flex-direction: column;
    .allData {
      flex: 1;
      position: relative;
      // 以前数据数值为350
      width: 90%;
      height: 41% !important;
      overflow: hidden;
      height: auto;
      margin: 0 auto;
      // border-bottom: 1px solid rgba(131, 144, 229, 1);
      .sm-allData {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        ul {
          cursor: pointer;
          line-height: 22px;
          overflow: hidden;
          position: relative;

          &:hover {
            background: rgba(49, 53, 79, 1);
          }

          li {
            width: 20%;
            font-size: 13px;
            float: left;
            text-align: center;
            color: #ffffff;
          }
        }
      }
    }
    .allDataBottom {
      flex: 1;
      overflow: hidden;
      // 以前数据数值为350
      width: 90%;
      height: 41%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      /* margin-top: 3%; */
      ul {
        cursor: pointer;
        line-height: 22px;
        overflow: hidden;
        position: relative;

        &:hover {
          background: rgba(49, 53, 79, 1);
        }

        li {
          width: 20%;
          font-size: 13px;
          float: left;
          text-align: center;
          color: #D7DDE8;
        }
      }
    }
  }
}

.latestactive {
  position: absolute;
  height: 20px;
  top: 0;
  right: 0;
  z-index: 1;
  background: #D94066;
  opacity: 0.4;
  width: 0%;
  transition: width 1s;
}

.latest__sellactive {
  position: absolute;
  height: 20px;
  top: 0;
  right: 0;
  z-index:1;
  background: #41B37D;
  opacity: 0.4;
  width: 0%;
  transition: width 1s;
}

.lineBoxColumn {
  position: absolute;
  top: 0;
  left: 52%;
  bottom: 0;
  width: 2px;
  margin: 0 2px;
  background: linear-gradient(45deg,
      rgba(94, 101, 146, 0.4) 0%,
      #464c74 62%,
      rgba(48, 53, 89, 0.4) 100%);
}

//横线
.hr {
  position: absolute;
  top: 144px;
  left: 50%;
  margin-left: -50%;
  width: 100%;
  height: 1px;
  background-color: rgba(131, 144, 229, 1);
}

.sm-allData {
  position: absolute;
  bottom: 0;
  top: 0;
  width: 100%;
  height: auto;
}

.allDataBottom {
  /* margin-top: 20px !important; */
}

.lineBox {
  width: 100%;
  margin: 1px auto;
  height: 1px;
  // background: linear-gradient(
  //   45deg,
  //   rgba(94, 101, 146, 0.4) 0%,
  //   #464c74 53%,
  //   rgba(48, 53, 89, 0.4) 100%
  // );
  background: rgba(22, 38, 50, .5);
}

.flex {
  display: flex;
}

.selldj {
  // width:60%;
  width: 100%;
  margin: 0 auto;
  height: 22px;
  line-height: 29px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #909399;
  text-indent: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  // background-color:#131625;
}

.selldj1 {
  width: 40%;
}

.calcFormula {
  position: absolute;
  top: -35px;
  right: 50px;
  background-color: #2C2C2C;
  width: 180px;
  padding: 14px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  z-index: 1002;

  div {
    color: #fff;
  }
}

</style>
